import { IconButton, SwipeableDrawer } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import HistoryIcon from "@mui/icons-material/History";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom";
import ListRow from "../atomic/ui/ListRow";
import { Auth } from "aws-amplify";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

const drawerWidth = 300;

export default function RightDrawer() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
  }));

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleSignOut = async () => {
    await Auth.signOut();
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{ padding: "unset", margin: "unset" }}
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        anchor="right"
        open={open}
        onOpen={handleDrawerOpen}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        onClose={handleDrawerClose}
      >
        <DrawerHeader>
          <img src={process.env.PUBLIC_URL + "/noshLogo.svg"} alt="nosh" />
        </DrawerHeader>
        <List>
          <ListRow
            key="dashboard"
            text="ダッシュボード"
            icon={<HomeOutlinedIcon />}
            onClick={() => handleNavigate("mypage/accounts")}
          />
          <Divider />
          <ListRow
            key="news"
            text="お知らせ"
            icon={<NotificationsNoneOutlinedIcon />}
            onClick={() => handleNavigate("/news")}
          />
          <Divider />
          <ListRow
            key="history"
            text="報酬履歴"
            icon={<HistoryIcon />}
            onClick={() => handleNavigate("mypage/history")}
          />
          <Divider />
          <ListRow
            key="transfer"
            text="報酬設定"
            icon={<PaidOutlinedIcon />}
            onClick={() => handleNavigate("mypage/reward/setting")}
          />
          <Divider />
          <ListRow
            key="faq"
            text="よくあるご質問"
            icon={<HelpOutlineOutlinedIcon />}
            onClick={() => handleNavigate("/faq")}
          />
          <Divider />
          <ListRow
            key="contact"
            text="お問い合わせ"
            icon={<MailOutlineOutlinedIcon />}
            onClick={() => handleNavigate("/contact")}
          />
          <Divider />
          <ListRow
            key="agreement"
            text="利用規約"
            icon={<ArticleOutlinedIcon />}
            onClick={() => handleNavigate("/agreement")}
          />
          <Divider />
          <ListRow
            key="logout"
            text="ログアウト"
            icon={<LogoutOutlinedIcon />}
            onClick={() => handleSignOut()}
          />
          <Divider />
          <ListRow
            key="unsubscribe"
            text="退会"
            isPrimary
            onClick={() => handleNavigate("mypage/unsubscribe")}
          />
        </List>
      </SwipeableDrawer>
    </>
  );
}
